import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { Center, Spinner } from 'wss3-forge'
import { useAuth } from '../contexts/AuthContext.js'

const RETURN_URL_KEY = 'webba_return_url'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <Center style={{ minHeight: '100dvh' }}>
        <Spinner size="lg" label="Chargement…" />
      </Center>
    )
  }

  if (!user) {
    sessionStorage.setItem(RETURN_URL_KEY, location.pathname + location.search)
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
